module.exports = __webpack_public_path__ + "static/media/eeurope-logo-white.a1e1998e.png";